/*  Centralised axios wrapper  */
import axios from 'axios';

/**
 * Normalizes the API base:
 * - If env is empty  -> '/api'
 * - If absolute URL  -> trim trailing slash and ensure it ends with '/api'
 * - If relative path -> use as-is (trim trailing slash). In prod set '/api'.
 */
function normalizeBase(v) {
  let b = (v || '').trim();
  if (!b) return '/api';

  // Absolute URL?
  if (/^https?:\/\//i.test(b)) {
    b = b.replace(/\/+$/, '');           // drop trailing slashes
    if (!/\/api(?:\/)?$/i.test(b)) b += '/api'; // ensure /api suffix for absolute URLs
    return b;
  }

  // Relative path
  if (!b.startsWith('/')) b = '/' + b;
  return b.replace(/\/+$/, ''); // '/api' recommended in production
}

const BASE = normalizeBase(process.env.REACT_APP_API_URL);

const API = axios.create({
  baseURL: BASE,
  // withCredentials: true, // enable only if you actually use cookies
});

/* -------- request interceptor: attach JWT -------- */
API.interceptors.request.use(cfg => {
  try {
    const raw   = localStorage.getItem('user');
    const store = raw ? JSON.parse(raw) : {};
    const token = store.token ?? localStorage.getItem('token');
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
  } catch (_) { /* ignore JSON parse errors */ }
  return cfg;
});

/* -------- response interceptor --------
   - 401: auto-logout
   - 428: force change password flow
--------------------------------------- */
API.interceptors.response.use(
  res => res,
  err => {
    const status = err?.response?.status;

    if (status === 401) {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    if (status === 428) {
      sessionStorage.setItem('pw_change_required', '1');
      if (!window.location.pathname.startsWith('/change-password-first')) {
        window.location.href = '/change-password-first';
      }
    }

    return Promise.reject(err);
  }
);

export default API;
